/* eslint-disable no-debugger */
import { createSlice } from '@reduxjs/toolkit'

// TODO: Volume level will eventually be per music, fx, narrator, etc. Global On / Off
const INITIAL_STATE = {
    volumeLevel: 0,
    soundEffectEnabled: false,
    musicEnabled: false,
    isFading: false,
    hasInteracted: false,
    musicSourceOne: null,
    musicSourceTwo: null,
    activeMusicSource: 'musicSourceOne'
}


const soundSlice = createSlice({
    name: 'sound',
    initialState: INITIAL_STATE,
    reducers: {
        setHasInteracted(state) {
            state.hasInteracted = true
        },
        setMusicSource(state, action) {
            // TODO: check the source is actually changing
            if (state.activeMusicSource === 'musicSourceOne') {
                state.activeMusicSource = 'musicSourceTwo'
                state.musicSourceTwo = action.payload
            } else {
                state.activeMusicSource = 'musicSourceOne'
                state.musicSourceOne = action.payload
            }
        },
        clearMusicSource(state) {
            state.activeMusicSource = null
            state.musicSourceOne = null
            state.musicSourceTwo = null
        },
        saveVolume(state, action) {
            state.volumeLevel = action.payload.volumeLevel
        },
        saveSoundEffectStatus(state, action) {
            state.soundEffectEnabled = !state.soundEffectEnabled
        },
        saveMusicStatus(state, action) {
            state.musicEnabled = !state.musicEnabled
        },
        disableMusic(state) {
            state.musicEnabled = false
        },
        startFadeIn(state) {
            state.isFading = true
        },
        startFadeOut(state) {
            state.isFading = true
        },
        completeFade(state) {
            state.isFading = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase('nav/completeAnimatingIn', (state) => {
                if (state.musicEnabled) {
                    state.isFading = true
                }
            })
            .addCase('nav/completeAnimatingOut', (state) => {
                if (state.musicEnabled) {
                    state.isFading = true
                }
            })
    }
})

export const {
    setHasInteracted, setMusicSource, disableMusic, clearMusicSource, saveVolume, saveSoundEffectStatus, saveMusicStatus, startFadeIn, startFadeOut, completeFade
} = soundSlice.actions
export default soundSlice.reducer


